import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b6a2c15c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "after-sale-describe"
};
const _hoisted_2 = {
  class: "status"
};
const _hoisted_3 = {
  key: 0,
  class: "line"
};
const _hoisted_4 = {
  key: 1,
  class: "rule"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 2,
  class: "cp-address"
};
const _hoisted_7 = {
  class: "cp-address-header"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_address_icon.png"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "header"
}, "退货地址", -1));
const _hoisted_10 = {
  class: "cp-address-cont"
};
const _hoisted_11 = {
  class: "receive"
};
const _hoisted_12 = {
  key: 3,
  class: "btn-list"
};
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("strong", _hoisted_2, _toDisplayString($props.status_describe.status), 1), $props.status_describe.rule && $props.status_describe.rule.length || $props.cp_address && $props.cp_address.receive_name || $props.btn_list && $props.btn_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true), $props.status_describe.rule && $props.status_describe.rule.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.status_describe.rule, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      key: index,
      innerHTML: item
    }, null, 8, _hoisted_5);
  }), 128))])) : _createCommentVNode("", true), $props.cp_address && $props.cp_address.receive_name ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("span", {
    class: "copy",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.CopyContent($event), ["stop"]))
  }, "复制")]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, _toDisplayString($props.cp_address.receive_name) + " " + _toDisplayString($props.cp_address.receive_phone), 1), _createElementVNode("div", _hoisted_11, _toDisplayString($props.cp_address.receive_address), 1)])])) : _createCommentVNode("", true), $props.btn_list && $props.btn_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.btn_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['btn-item', {
        'btn-item-active': item.type == 'aftersale_write_express_no'
      }]),
      onClick: $event => $options.btnClick(item)
    }, _toDisplayString(item.title), 11, _hoisted_13);
  }), 128))])) : _createCommentVNode("", true)]);
}